/**
 * Utility functions for handling field options in forms
 */

/**
 * Default options for common field types
 */
export const DEFAULT_FIELD_OPTIONS = {
  gender: [
    { value: 'MALE', label: 'Male' },
    { value: 'FEMALE', label: 'Female' },
    { value: 'OTHER', label: 'Other' }
  ],
  boolean: [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' }
  ]
};

/**
 * Get default options for a field based on field name or type
 * @param {string} fieldName - The name of the field
 * @param {string} fieldType - The type of the field
 * @returns {Array} - Array of options objects with value and label properties
 */
export const getDefaultOptions = (fieldName, fieldType) => {
  // Convert to lowercase for case-insensitive matching
  const name = fieldName?.toLowerCase() || '';
  const type = fieldType?.toLowerCase() || '';
  
  // Check for gender fields
  if (name.includes('gender') || name.includes('sex')) {
    return DEFAULT_FIELD_OPTIONS.gender;
  }
  
  // Check for boolean fields
  if (type === 'boolean' || name.includes('is_') || name.includes('has_')) {
    return DEFAULT_FIELD_OPTIONS.boolean;
  }
  
  return [];
};

/**
 * Ensures field options are in the correct format
 * @param {Array|Object} options - Options as array or object
 * @returns {Array} - Properly formatted options array
 */
export const formatFieldOptions = (options) => {
  if (!options) return [];
  
  // If already in correct format, return as is
  if (Array.isArray(options) && options.length > 0 && typeof options[0] === 'object' && options[0].hasOwnProperty('value')) {
    return options;
  }
  
  // Convert array of strings to proper format
  if (Array.isArray(options)) {
    return options.map(opt => {
      if (typeof opt === 'string' || typeof opt === 'number') {
        return { value: opt.toString(), label: opt.toString() };
      }
      return opt;
    });
  }
  
  // Convert object to array of options
  if (typeof options === 'object') {
    return Object.entries(options).map(([key, value]) => ({
      value: key,
      label: value
    }));
  }
  
  return [];
};
